import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
} from "@mui/material";

function AwardBatchAccordion(props) {
    const names = [
        "Sadeeq Fahass",
        "Farouq Umar",
        "Adbulazeez Sani",
        "Umar Idris",
        "Ibrahim Abubakar",
        "Sulaiman Kabir",
        "Umar Idris",
        "Sadeeq Fahass",
        "Umar Idris",
        "Sadeeq Fahass",
        "Adbulazeez Sani",
        "Umar Idris",
        "Ibrahim Abubakar",
        "Sulaiman Kabir",
        "Umar Idris",
        "Sadeeq Fahass",
        "Umar Idris",
        "Ibrahim Abubakar",
        "Sulaiman Kabir",
        "Umar Idris",
        "Sadeeq Fahass",
        "Umar Idris",
        "Sadeeq Fahass",
        "Adbulazeez Sani",
        "Umar Idris",
        "Ibrahim Abubakar",
        "Sulaiman Kabir",
        "Umar Idris",
        "Ibrahim Abubakar",
        "Sulaiman Kabir",
        "Umar Idris",
        "Sadeeq Fahass",
        "Umar Idris",
        "Sadeeq Fahass",
        "Adbulazeez Sani",
        "Umar Idris",
        "Ibrahim Abubakar",
        "Sulaiman Kabir",
      ];
  return (
    <div className="p-2">
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <p>
            <p className="font-bold">{props.batch}</p>{" "}
          </p>
        </AccordionSummary>
        <AccordionDetails>
          <div className="bg-slate-50 p-4 h-96 rounded-lg overflow-auto">
          <ul className="ver-aside-ul p-3">
          {names.map((name, index) => (
            <li key={index} >
              <AccountCircleIcon /> {name}  
            </li>
          ))}
        </ul>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default AwardBatchAccordion;
